import type { RopaReviewRoundStatus } from 'config/api/ropaReviews/ropaReviews.types';

import { isReviewLocked } from './assetRopaReviewHelpers';

export type AssetRopaPageVariant = 'admin' | 'owner';

export type AssetRopaCapabilities = {
  variant: AssetRopaPageVariant;
  canStartReview: boolean;
  canEditReviewDetails: boolean;
  canCompleteReview: boolean;
  canCancelReview: boolean;
  canBulkAccept: boolean;
  canAcceptRow: boolean;
  canRequestClarificationFromList: boolean;
  canAddProcessingActivity: boolean;
  canRemoveProcessingActivity: boolean;
  canAssessDpia: boolean;
  canOpenAdminDpiaReview: boolean;
  canOpenAdminReviewPage: boolean;
  canOpenApaEditor: boolean;
  canEditApa: boolean;
  showAdminAssetMenu: boolean;
  showBulkAcceptFooter: boolean;
  reviewPanelAdminActions: boolean;
  metricsIncludedAssetsMessageKey: 'included_assets' | 'owner_included_assets';
  pageTitleMessageKey: 'page_title' | 'owner_page_title';
  pageSubtitleMessageKey: 'page_subtitle' | 'owner_page_subtitle';
  pageHelpMessageKey: 'page_help' | 'owner_page_help';
};

export const resolveAssetRopaCapabilities = (
  variant: AssetRopaPageVariant,
  reviewStatus?: RopaReviewRoundStatus,
): AssetRopaCapabilities => {
  const locked = reviewStatus ? isReviewLocked(reviewStatus) : false;
  const isAdmin = variant === 'admin';

  return {
    variant,
    canStartReview: isAdmin && !locked,
    canEditReviewDetails: isAdmin && !locked,
    canCompleteReview: isAdmin && !locked,
    canCancelReview: isAdmin && !locked,
    canBulkAccept: isAdmin && !locked,
    canAcceptRow: isAdmin && !locked,
    canRequestClarificationFromList: isAdmin && !locked,
    // Asset ROPA↔APA linking is owner-only. Admin may review all Asset ROPA records but not edit links unless also owner.
    canAddProcessingActivity: !isAdmin && !locked,
    canRemoveProcessingActivity: !isAdmin && !locked,
    canAssessDpia: isAdmin,
    canOpenAdminDpiaReview: isAdmin,
    canOpenAdminReviewPage: isAdmin,
    canOpenApaEditor: !isAdmin,
    canEditApa: !isAdmin && !locked,
    showAdminAssetMenu: isAdmin && !locked,
    showBulkAcceptFooter: isAdmin && !locked,
    reviewPanelAdminActions: isAdmin,
    metricsIncludedAssetsMessageKey: isAdmin ? 'included_assets' : 'owner_included_assets',
    pageTitleMessageKey: isAdmin ? 'page_title' : 'owner_page_title',
    pageSubtitleMessageKey: isAdmin ? 'page_subtitle' : 'owner_page_subtitle',
    pageHelpMessageKey: isAdmin ? 'page_help' : 'owner_page_help',
  };
};
